import { createSelector } from 'reselect'
import { getShareModalConfig } from 'lib/customer/getShareModalConfig'
import config from 'constants/config'
import defaultIntl from 'i18n/util/defaultIntl'
import { UTM_CAMPAIGN_CRUISE_E2E_FLOW } from 'constants/cruise'
import { Experiments } from 'constants/experiments'
import { getOptimizelyExperimentVariation, getExperimentEnabledDecision } from 'lib/optimizely/optimizelyUtils'

export const getCruiseDealShareModalConfig = createSelector(
  (appState: App.State) => appState.system.customerPortalURL,
  (appState: App.State) => appState.auth.account.memberId,
  (appState: App.State) => appState.router.location.pathname,
  (appState: App.State) => appState.geo.currentRegionCode,
  (appState: App.State, currentCruiseDeal: App.Cruises.CruiseDeal) => currentCruiseDeal,
  (
    customerPortalURL,
    memberId,
    pathname,
    region,
    cruiseDeal,
  ) => {
    return cruiseDeal ?
        getShareModalConfig({
          customerPortalURL,
          memberId: memberId || '',
          offerId: cruiseDeal.id,
          offerLocation: cruiseDeal.name,
          pathname,
          region,
          type: 'page',
          utmCampaign: 'webshare',
          offerType: 'cruise',
          intl: defaultIntl,
        }) :
      undefined
  },
)

export const isStandaloneCruiseEnabled = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (regionCode) => config.CRUISES_STANDLONE_ENABLED && config.CRUISES_REGIONS?.split(',')?.includes(regionCode),
)

/**
 * Offer-page early traveller selection (dates modal before checkout).
 * `UTM_CAMPAIGN_CRUISE_E2E_FLOW` forces the classic checkout flow off the offer page (no modal),
 * same idea as using UTM to pin experiment behaviour for cruise E2E.
 */
export const getIsCruiseOfferEarlyTravellerSelectionEnabled = createSelector(
  (state: App.State) => getOptimizelyExperimentVariation(state, Experiments.cruiseOfferPageEarlyTravellerSelection.id),
  (state: App.State) => state.utm.campaign,
  (experimentVariation, utmCampaign): boolean => {
    if (utmCampaign === UTM_CAMPAIGN_CRUISE_E2E_FLOW) {
      return false
    }
    return getExperimentEnabledDecision(experimentVariation ?? null)
  },
)
